import { jsx as c, Fragment as p, jsxs as h } from "react/jsx-runtime";
import { c as w } from "react/compiler-runtime";
import { useEffect as l, useRef as x } from "react";
import { M } from "../../../chunks/index.esm.js";
import { renderToString as m } from "react-dom/server";
async function P(t, e) {
  const o = new google.maps.Geocoder();
  return new Promise((n, r) => {
    let i = "";
    o?.geocode({
      location: {
        lat: t,
        lng: e
      }
    }, (s, a) => {
      a === "OK" ? s?.[0] ? (i = s[0].formatted_address, n(i)) : (i = "No results found", n(i)) : (i = "Geocoder failed due to: " + a, r(i));
    });
  });
}
function b(t, e) {
  const o = m(/* @__PURE__ */ c(p, { children: /* @__PURE__ */ h("div", { style: {
    color: "white",
    display: "inline-flex",
    alignItems: "center",
    gap: 5,
    marginTop: 10,
    padding: 10,
    maxWidth: 180
  }, children: [
    /* @__PURE__ */ c("img", { src: e.icon, alt: e.name, width: 18, height: 18 }),
    /* @__PURE__ */ c("span", { children: e.name })
  ] }) }));
  new google.maps.InfoWindow({
    content: o,
    position: e.geometry?.location,
    ariaLabel: e.name
  }).open(t), e.geometry?.viewport && (t.fitBounds(e.geometry.viewport), e.geometry.location && t.setCenter(e.geometry.location));
}
async function L(t, e, o, n) {
  if (!(!t || !e) && (e.position = t.getCenter(), n)) {
    const r = t.getCenter().toJSON(), i = await P(r.lat, r.lng), s = {
      id: o ?? "Custom",
      location: {
        lat: r.lat,
        lng: r.lng,
        address: i
      },
      label: e.title ?? "",
      metadata: {
        resetToMapCenter: !0
      }
    };
    n(s);
  }
}
function z(t, e, o, n) {
  l(() => {
    if (!e) return;
    let r;
    return t && (r = new google.maps.Marker({
      position: o,
      map: e,
      draggable: !0,
      icon: {
        url: "https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2.png",
        scaledSize: new google.maps.Size(20, 30),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(10, 30)
      },
      zIndex: Number(google.maps.Marker.MAX_ZINDEX) + 1
    }), r.addListener("dragend", () => {
      const i = r.getPosition()?.toJSON();
      i && n(i);
    })), google.maps.event.addListener(e, "dragend", () => {
      const i = e.getCenter();
      r?.setPosition(i), i && n(i.toJSON());
    }), () => {
      r?.setMap(null);
    };
  }, [e, t]);
}
function O(t, e, o) {
  const n = x(void 0);
  return l(() => {
    if (!(!e || !t))
      return n.current?.clearMarkers(), n.current = new M({
        map: e,
        markers: o,
        renderer: v
      }), () => {
        n.current?.clearMarkers();
      };
  }, [t, e, o.length]), n;
}
function j(t, e) {
  const o = w(4);
  let n, r;
  o[0] !== e || o[1] !== t ? (n = () => {
    if (t)
      return e.forEach((i) => {
        t.controls[google.maps.ControlPosition.TOP_RIGHT].push(i);
      }), () => {
        t.controls[google.maps.ControlPosition.TOP_RIGHT].clear();
      };
  }, r = [t, e], o[0] = e, o[1] = t, o[2] = n, o[3] = r) : (n = o[2], r = o[3]), l(n, r);
}
const v = {
  render: function(t) {
    const e = document.createElement("div");
    return e.style.cssText = `
      width: 50px;
      height: 50px;
      background-color: #226a58;
      border: 3px solid white;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-weight: bold;
      font-size: 12px;
      font-family: Arial, sans-serif;
      box-shadow: 0 2px 6px rgba(0,0,0,0.3);
    `, e.textContent = t.count.toString(), new google.maps.marker.AdvancedMarkerElement({
      position: t.position,
      content: e,
      zIndex: 1e3 + t.count
    });
  }
}, E = (t) => {
  const e = document.createElement("div"), o = m(t);
  e.innerHTML = o;
  const n = e.querySelector("svg");
  if (!n) return "";
  const r = new XMLSerializer().serializeToString(n);
  return e.remove(), `data:image/svg+xml;charset=utf-8,${encodeURIComponent(r)}`;
}, N = (t, e, o) => {
  const n = t.position;
  if (!n || !o.getProjection()) return [];
  const r = Math.pow(2, o.getZoom() || 0), i = o.getProjection().fromLatLngToPoint(n), s = 30;
  return e.filter((a) => {
    const g = a.position;
    if (!g) return !1;
    const d = t.markerId, f = a.markerId;
    if (d && f && f === d)
      return !1;
    const u = o.getProjection().fromLatLngToPoint(g);
    return Math.sqrt(Math.pow((i.x - u.x) * r, 2) + Math.pow((i.y - u.y) * r, 2)) < s;
  });
};
export {
  v as AdvancedMarkerCustomRenderer,
  E as convertSvgToUrl,
  N as findOverlappingMarkers,
  P as generateAddress,
  L as resetMarkerToCenter,
  b as updateMapWithPlace,
  z as useCenterMarker,
  j as useMapControls,
  O as useMarkerCluster
};
